import { render, staticRenderFns } from "./international_freight.vue?vue&type=template&id=ec014bec&scoped=true&"
import script from "./international_freight.vue?vue&type=script&lang=js&"
export * from "./international_freight.vue?vue&type=script&lang=js&"
import style0 from "./international_freight.vue?vue&type=style&index=0&id=ec014bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec014bec",
  null
  
)

export default component.exports